export const TOP_CITIES = [
    { city: 'Asheville', url: 'asheville-nc', state: 'NC' },
    { city: 'Atlanta', url: 'atlanta-ga', state: 'GA' },
    { city: 'Austin', url: 'austin-tx', state: 'TX' },
    { city: 'Boston', url: 'boston-ma', state: 'MA' },
    { city: 'Charlotte', url: 'charlotte-nc', state: 'NC' },
    { city: 'Chicago', url: 'chicago-il', state: 'IL' },
    { city: 'Columbus', url: 'columbus-oh', state: 'OH' },
    { city: 'Dallas', url: 'dallas-tx', state: 'TX' },
    { city: 'Denver', url: 'denver-co', state: 'CO' },
    { city: 'Houston', url: 'houston-tx', state: 'TX' },
    { city: 'Jacksonville', url: 'jacksonville-fl', state: 'FL' },
    { city: 'Las Vegas', url: 'las-vegas-nv', state: 'NV' },
    { city: 'Los Angeles', url: 'los-angeles-ca', state: 'CA' },
    { city: 'Miami', url: 'miami-fl', state: 'FL' },
    { city: 'Minneapolis', url: 'minneapolis-mn', state: 'MN' },
    { city: 'New York', url: 'new-york-ny', state: 'NY' },
    { city: 'Phoenix', url: 'phoenix-az', state: 'AZ' },
    { city: 'Portland', url: 'portland-or', state: 'OR' },
    { city: 'Sacramento', url: 'sacramento-ca', state: 'CA' },
    { city: 'San Antonio', url: 'san-antonio-tx', state: 'TX' },
    { city: 'San Diego', url: 'san-diego-ca', state: 'CA' },
    { city: 'San Francisco', url: 'san-francisco-ca', state: 'CA' },
    { city: 'Seattle', url: 'seattle-wa', state: 'WA' },
    { city: 'Spokane', url: 'spokane-wa', state: 'WA' },
    { city: 'Washington DC', url: 'washington-dc', state: 'DC' },
];

export const TOP_CITIES_CA = [
    { city: 'Calgary', url: 'calgary-ab', state: 'AB' },
    { city: 'Edmonton', url: 'edmonton-ab', state: 'AB' },
    { city: 'Ottawa', url: 'ottawa-on', state: 'ON' },
    { city: 'Toronto', url: 'toronto-on', state: 'ON' },
    { city: 'Vancouver', url: 'vancouver-bc', state: 'BC' },
];
